<template>
  <div class="wrap">
    <top-header
      class="top-header"
      :showWebsite="false"
      :showLoginBtn="false"
      :showLangSelector="false"
    ></top-header>
    <div class="bank-transfer">
      <div class="bank-transfer_main">
        <div class="bank-transfer_title">
          <div class="bank-transfer_close" @click.stop="backToSelect">
            重新選擇
          </div>
          銀行匯款信息
        </div>
        <div class="bank-transfer_info">
          <p
            class="bank-transfer_info-item"
            v-for="item in transferInfo"
            :key="item.id"
          >
            <span class="bank-transfer_info-left">{{ item.label }}</span>
            <span v-if="item.id !== 1" class="bank-transfer_info-right">
              {{ item.value }}
            </span>
            <input
              class="bank-transfer_info-right black"
              v-else
              readonly
              type="text"
              v-model="item.value"
            />
          </p>
        </div>
        <div class="bank-transfer_tips">
          注：每次交易由銀行自動生成一個新的儲值賬號。每個儲值賬號只能使用一次。
        </div>
        <div class="bank-transfer_tips red">
          若實際匯款金額和儲值金額不符將會導致儲值失敗
          ，請牢記匯款金額和匯款帳號。
        </div>
        <div class="bank-transfer_desc-title">操作說明：</div>
        <div class="bank-transfer_desc">
          <div class="bank-transfer_desc-time">
            <p class="bank-transfer_desc-row mt0">1.儲值服務時間：</p>
            <table
              class="bank-transfer_desc-table"
              aria-describedby="bank-desc"
            >
              <tbody>
                <tr>
                  <td class="bank-transfer_desc-tfirst">
                    ◇銀行網路匯款儲值轉帳時間
                  </td>
                  <td class="bank-transfer_desc-tsecond">24小時</td>
                </tr>
                <tr>
                  <td class="bank-transfer_desc-tfirst">
                    ◇ATM轉帳儲值轉帳時間
                  </td>
                  <td class="bank-transfer_desc-tsecond">24小時</td>
                </tr>
                <tr>
                  <td class="bank-transfer_desc-tfirst">
                    ◇銀行臨櫃匯款儲值轉帳時間
                  </td>
                  <td class="bank-transfer_desc-tsecond">9:00-15:30</td>
                </tr>
                <tr>
                  <td class="bank-transfer_desc-tfirst">
                    ◇郵局匯款儲值轉帳時間
                  </td>
                  <td class="bank-transfer_desc-tsecond">8:00-17:00</td>
                </tr>
              </tbody>
            </table>
            <span class="bank-transfer_desc-remit">
              ◇銀行網路匯款儲值、ATM儲值一般15分鐘內到帳，其餘儲值方式的到帳時間為:週一到週四15：30後匯款需隔天到帳，週五15：30後匯款需下週一到帳。
            </span>
            <p></p>
            <p class="bank-transfer_desc-row">
              2.為維護自身權益，轉帳完成後請保留匯款單據。
            </p>
            <p class="bank-transfer_desc-row">
              3.儲值過程中如果遇到任何問題，請聯繫我們的客服。
            </p>
            <p class="bank-transfer_desc-row">
              4.儲值金額將一次性轉為遊戲貨幣，無法分開帳號或同一帳號分多次儲值。
            </p>
            <p class="bank-transfer_desc-row">5.發票處理方式：</p>
          </div>
          <div class="bank-transfer_desc-invoice">
            <label>
              <input
                type="radio"
                name="invoice"
                value="charitable"
                :disabled="disabled"
                v-model="invoiceType"
                class="bank-transfer_desc-radio"
              />
              <span
                class="bank-transfer_desc-radio text"
                :class="{ active: invoiceType === 'charitable' }"
                >慈善捐贈</span
              >
            </label>
            <label>
              <input
                type="radio"
                name="invoice"
                value="invoice"
                :disabled="disabled"
                v-model="invoiceType"
                class="bank-transfer_desc-radio"
              />
              <span
                class="bank-transfer_desc-radio text"
                :class="{ active: invoiceType === 'invoice' }"
                >索取發票</span
              >
            </label>
            <label>
              <input
                type="radio"
                name="invoice"
                value="electronic"
                :disabled="disabled"
                v-model="invoiceType"
                class="bank-transfer_desc-radio"
              />
              <span
                class="bank-transfer_desc-radio text"
                :class="{ active: invoiceType === 'electronic' }"
                >載具發票</span
              >
            </label>
          </div>
          <div class="bank-transfer_desc-charitable">
            <transition-group name="fade">
              <template v-if="invoiceType === 'invoice'">
                <input
                  type="text"
                  key="bankName"
                  v-model="bankName"
                  placeholder="銀行帳號"
                  class="bank-transfer_desc-input"
                />
                <input
                  type="text"
                  key="realName"
                  v-model="realName"
                  placeholder="真實姓名"
                  class="bank-transfer_desc-input"
                />
                <input
                  type="text"
                  key="postAddress"
                  v-model="postAddress"
                  placeholder="郵寄住址"
                  class="bank-transfer_desc-input"
                />
                <input
                  type="text"
                  key="postArea"
                  v-model="postArea"
                  placeholder="郵遞區號"
                  class="bank-transfer_desc-input"
                />
              </template>
              <template v-if="invoiceType === 'electronic'">
                <label class="bank-transfer_desc-label" key="label">
                  <span class="bank-transfer_desc-radio">載具選擇：</span>
                  <input
                    checked
                    type="radio"
                    class="bank-transfer_desc-radio"
                  />
                  <span class="bank-transfer_desc-radio">載具發票</span>
                </label>
                <input
                  type="text"
                  key="mobileCode"
                  v-model="mobileCode"
                  class="bank-transfer_desc-input"
                  placeholder="載具發票（必須/開頭，只能輸入八碼英數字符號 , 英文需大寫，示例：/0U5B8+P）"
                />
                <input
                  type="text"
                  key="bankAccount"
                  v-model="bankAccount"
                  placeholder="銀行帳號"
                  class="bank-transfer_desc-input"
                />
                <p key="tips" class="bank-transfer_desc-tips">
                  溫馨提示：載具發票請於儲值當日填寫提交，超過儲值當日請點擊索取發票，填寫可收件地址，我們將把紙本發票郵寄給您
                </p>
              </template>
            </transition-group>
            <Button
              v-if="invoiceType !== 'charitable'"
              class="bank-transfer_desc-btn"
              @click="confirmMsg"
            >
              確認
            </Button>

            <div class="donate-code" v-if="invoiceType === 'charitable'">
              <div v-if="!boolGlobalPage">
                <p
                  class="bank-transfer_desc-row orange-text"
                  style="height: auto; width: 100%"
                >
                  1.慈善捐贈：我們會將您的愛心傳遞給社團法人台灣偵搜犬協會，謝謝您！
                  網址：
                  <a
                    class="animate-site-link"
                    href="//www.tdda.com.tw/tw"
                    target="_blank"
                  >
                    https://www.tdda.com.tw/tw
                  </a>
                </p>
              </div>
              <div v-else>
                <p
                  class="bank-transfer_desc-row orange-text"
                  style="height: auto; width: 100%"
                >
                  1.慈善捐贈：我們會將您的愛心傳遞給社團法人台灣偵搜犬協會（網址：
                  <a
                    class="animate-site-link"
                    href="//www.tdda.com.tw/tw"
                    target="_blank"
                  >
                    https://www.tdda.com.tw/tw
                  </a>
                  ），也可以在下方填入您想捐贈的受捐贈機關或團體的捐贈碼，謝謝您！
                </p>
                <input
                  type="text"
                  key="donateAccount"
                  v-model="donateAccount"
                  placeholder="銀行虛擬帳號"
                  class="bank-transfer_desc-input"
                />
                <input
                  type="text"
                  key="donateCode"
                  v-model="donateCode"
                  placeholder="捐贈碼"
                  class="bank-transfer_desc-input"
                />
                <Button class="bank-transfer_desc-btn" @click="confirmMsg">
                  確認
                </Button>
                <p class="bank-transfer_desc-row orange-text">
                  2.索取發票：我們會郵寄給您發票！
                </p>
              </div>
            </div>
            <div class="bank-transfer_desc-customer">
              <span>客服電話：09-66583330</span>
              <span>工作時間：09:00-17:00</span>
            </div>
          </div>
        </div>
      </div>
      <PopupWindow
        class="bank-tips"
        @onCancel="showPopup = false"
        @onConfirm="showPopup = false"
        type="tips"
        v-if="showPopup"
        :languages="letter"
        :content="errTips"
      ></PopupWindow>
      <ServiceIconBtn
        :serverId="pcServerId"
        :roleId="roleId"
        :roleName="roleName"
        :gameId="gameId"
        :isUidLogin="isUidLogin"
        :uid="uid"
        :loginAccount="loginAccount"
      ></ServiceIconBtn>
    </div>
  </div>
</template>

<script>
import { GET_INVOICE } from '@store/officialWebStore';
import TopHeader from '@components/officialWebStore/TopHeader.vue';
import ServiceIconBtn from '@components/officialWebStore/ServiceIcon.vue';
import { mapState } from 'vuex';
import { clickButton, locationType } from '@plugins/biPoint/_configWebstoreV2';
export default {
  name: 'BankDetailInfoPage',
  watch: {
    $route: {
      deep: true,
      immediate: true,
      handler(to) {
        this.resetInvoice();
        this.virtualAccount = to.query?.account;
        this.transAmount = to.query?.amount;
        this.setBankAccount(this.virtualAccount, this.transAmount);
      }
    }
  },
  data() {
    return {
      virtualAccount: '',
      transAmount: '',
      transferInfo: [
        {
          id: 1,
          label: '匯款卡號：',
          value: ''
        },
        {
          id: 2,
          label: '銀行代碼：',
          value: '013'
        },
        {
          id: 3,
          label: '匯款面額：',
          value: ''
        },
        {
          id: 4,
          label: '銀行名稱：',
          value: '國泰世華銀行-華山分行'
        },
        {
          id: 5,
          label: '銀行戶名：',
          value: '珩熠文化網路有限公司'
        }
      ],
      invoiceType: 'charitable',
      bankName: '',
      realName: '',
      postAddress: '',
      postArea: '',
      mobileCode: '',
      bankAccount: '',
      donateAccount: '', // 銀行虛擬帳號
      donateCode: '', // 捐贈碼
      disabled: true,
      showPopup: false,
      errTips: ''
    };
  },
  computed: {
    ...mapState({
      letter: state => state.letter,
      gameId: state => state.gameId,
      roleId: state => state.roleId,
      pcServerId: state => state.pcServerId,
      roleName: state => state.roleName,
      loginAccount: state => state.login.loginAccount,
      uid: state => state.login.uid,
      isUidLogin: state => state.login.isUidLogin
    }),
    boolGlobalPage() {
      return /blancozone.com/.test(window.location.host);
    }
  },
  methods: {
    backToSelect() {
      clickButton({
        btnName: 'back_select',
        locationKey: locationType.bankPage
      });
      this.$router.back();
    },
    resetInvoice() {
      this.invoiceType = 'charitable';
      this.bankName = '';
      this.realName = '';
      this.postAddress = '';
      this.postArea = '';
      this.mobileCode = '';
      this.bankAccount = '';
      this.donateAccount = '';
      this.donateCode = '';
    },
    setBankAccount(account, amount) {
      this.transferInfo.splice(
        0,
        1,
        Object.assign({}, this.transferInfo[0], { value: account })
      );
      this.transferInfo.splice(
        2,
        1,
        Object.assign({}, this.transferInfo[2], { value: amount })
      );
      this.bankName = account;
      this.bankAccount = account;
      this.disabled = false;
    },
    checkBankAccount(account) {
      if (!/\d{14}/gi.test(account)) {
        this.showCreateFaileTips('銀行帳號格式不正確，請校驗後再次提交');
        return false;
      }
      return true;
    },
    confirmMsg() {
      let params = {};
      switch (this.invoiceType) {
        case 'charitable': {
          let pass = this.checkBankAccount(this.donateAccount);
          if (!pass) return;
          if (!/^\d+$/.test(this.donateCode)) {
            this.showCreateFaileTips('請輸入正確的捐贈碼');
            return;
          }
          params = {
            virtual_account: this.donateAccount,
            dona_code: this.donateCode
          };
          break;
        }
        case 'invoice': {
          if (!this.realName || !this.postAddress || !this.postArea) {
            this.showCreateFaileTips('請填寫完整信息');
            return;
          }
          let pass = this.checkBankAccount(this.bankName);
          if (!pass) return;
          params = {
            virtual_account: this.bankName,
            invoice_title: this.realName,
            mail_addr: this.postAddress,
            mail_addr_num: this.postArea
          };
          break;
        }
        case 'electronic': {
          // 龚然：载具发票校验：/开头，只能输入8个字符
          if (!/^\/.{7}$/.test(this.mobileCode)) {
            this.showCreateFaileTips('請填寫正確載具發票');
            return;
          }
          let pass = this.checkBankAccount(this.bankAccount);
          if (!pass) return;
          params = {
            invoice_phone: this.mobileCode,
            virtual_account: this.bankAccount
          };
          break;
        }
      }
      this.$store
        .dispatch(GET_INVOICE, params)
        .then(() => {
          this.errTips = '提交成功';
          this.showPopup = true;
        })
        .catch(err => {
          this.showCreateFaileTips(err);
        });
    },
    showCreateFaileTips(err) {
      this.loading = false;
      let msg = typeof err === 'string' ? err : err.message;
      this.errTips = msg;
      this.showPopup = true;
    }
  },
  components: {
    ServiceIconBtn,
    TopHeader
  }
};
</script>

<style lang="scss" scoped>
@import '@assets/scss/officialWebStore/officialWebStore.scss';
.wrap {
  display: block;
  position: relative;
  width: 100%;
  height: auto;
  background-color: #f6f6f6;
}
.bank-detail-info {
  float: left;
  box-sizing: border-box;
  padding: 0 30px;
  width: 100%;
}
$themeColor: #e97d30;
$textColor: #333333;
$tipsColor: #666666;
.bank-transfer {
  box-sizing: border-box;
  padding: 25px 37px;
  &_main {
    margin: 0 auto;
    width: 450px * 2;
  }
  &_title {
    position: relative;
    padding-left: 24px;
    font-weight: 700;
    font-size: 36px;
    color: #333333;
  }
  &_close {
    display: block;
    position: absolute;
    right: 0;
    top: 5px;
    font-weight: normal;
    font-size: 22px;
    color: #b07d1a;
    border: 1px solid #b07d1a;
    border-radius: 40px;
    padding: 5px 20px;
    cursor: pointer;
  }
  &_info {
    margin-top: 32px;
    padding: 27px 24px;
    background: #fefefe;
    font-size: 22px;
    &-item {
      margin: 10px 0 0;
    }
    &-left {
      font-size: 22px;
      color: #333333;
    }
    &-right {
      margin-left: 10px;
      font-size: 22px;
      color: #333333;
    }
  }
  .refresh-content {
    padding: 10px * 2 0;
    font-size: 11px * 2.2;
    color: $themeColor;
    .refresh-btn {
      display: inline-block;
      box-sizing: border-box;
      border: 1px solid $themeColor;
      border-radius: 5px * 2;
      width: 52px * 2;
      height: 22px * 2;
      line-height: 22px * 2;
      text-align: center;
      color: $themeColor;
    }
  }
  &_tips {
    position: relative;
    margin-top: 10px;
    padding-left: 24px;
    line-height: 34px;
    font-size: 20px;
    color: $tipsColor;
    &.red {
      color: #b07d1a;
    }
  }
  &_btn {
    margin: 15px * 2 auto;
  }
  &_desc {
    margin-top: 30px;
    padding: 36px 24px;
    background: #fefefe;
    &-title {
      margin-top: 51px;
      padding-left: 24px;
      font-weight: bolder;
      font-size: 30px;
      color: $textColor;
    }
    &-table {
      border-collapse: collapse;
      border-spacing: 0;
      margin: 10px * 2 auto;
      width: 96%;
      td {
        border: 1px solid #333;
        height: 41px;
        line-height: 41px;
        text-align: center;
        font-size: 20px;
      }
      .bank-transfer_desc-tfirst {
        padding-left: 5%;
        width: 60%;
      }
      .bank-transfer_desc-tsecond {
        text-align: center;
      }
    }
    &-remit {
      line-height: 32px;
      font-size: 20px;
      color: $tipsColor;
    }
    &-row {
      margin-top: 15px;
      line-height: 36px;
      font-size: 22px;
      color: $textColor;
      &.orange-text {
        line-height: 28px;
        font-size: 20px;
        color: #999;
      }
    }
    .mt0 {
      margin-top: 0;
    }
    &-invoice {
      display: flex;
      justify-content: space-around;
      align-items: center;
      margin-top: 20px;
      text-align: center;
      font-size: 14px * 2;
      color: $textColor;
    }
    &-charitable {
      padding-top: 10px;
    }
    &-label {
      margin-top: 10px * 2;
      font-size: 20px;
      color: #999;
    }
    &-radio {
      display: inline-block;
      vertical-align: middle;
      &.text {
        width: 200px;
        height: 55px;
        background: #fff;
        line-height: 55px;
        text-align: center;
        font-size: 22px;
        color: #333;
        border-radius: 40px;
        @include g-border();
      }
    }
    &-input {
      display: flex;
      justify-content: center;
      align-items: center;
      width: 100%;
      box-sizing: border-box;
      font-size: 24px;
      position: relative;
      height: 83px;
      border-radius: 10px;
      border: 1px solid #999;
      color: #333;
      margin: 20px auto;
      padding: 0 20px;
      cursor: pointer;
    }
    &-btn {
      margin: 15px auto;
      font-size: 36px;
      display: flex;
      justify-content: center;
      width: 100%;
      line-height: 80px;
      height: 80px;
      color: #fff;
      background: $btnBg;
      border-radius: 10px;
      cursor: pointer;
    }
    &-tips {
      font-size: 20px;
      color: $tipsColor;
    }
    &-customer {
      margin-top: 30px;
    }
    &-customer > span {
      display: inline-block;
      width: 50%;
      text-align: center;
      font-size: 20px;
      color: $textColor;
    }
  }
  .animate-site-link {
    color: #b07d1a;
  }
}
@media screen and (orientation: portrait) {
  .bank-transfer {
    box-sizing: border-box;
    margin-top: 10px * 2;
    padding: 12px * 2 17px * 2;
    &_main {
      margin: 0 auto;
      width: 100%;
    }
  }
}
.bank-tips {
  ::deep .tips-content {
    display: block;
    box-sizing: border-box;
  }
}
.fade-enter-active,
.fade-leave-active {
  transition: all 0.3s cubic-bezier(0.4, 0, 1, 1);
}
.fade-leave-active {
  display: none;
}
.fade-enter,
.fade-leave-to {
  opacity: 0;
  transform: translate3d(50%, 0, 0);
}
.top-header {
  position: relative;
}
</style>
